import moment from "moment";
import { LoadState } from "../../constants/enums";
import { ICustomer } from "./customer.types";
import { STANDARD_APP_DATE_FORMAT } from "../../constants/constants";

export const initialCustomerState: ICustomer = {
  personalInformation: {
    data: {
      customer_id: null,
      salutation: "",
      first_name: "",
      last_name: "",
      goes_by: "",
      position: "",
      mobile: "",
      phone: "",
      phone_ext: "",
      email: "",
      status: "ACTIVE",
      customer_name: "",
      csr: "",
      customer_code: "",
      form_of_business: "",
      tax_zone: "ON",
      mailing_address: "",
      language: "E",
      producer: "",
      marketer: "",
      branch: "",
      assigned_to_id: null,
      city: "",
      province_or_state: "",
      country: "",
      postal_code: "",
      unit_or_suite: "",
      assigned_to_code: "",
      csr_code: "",
      marketer_code: "",
      producer_code: "",
      branch_code: "",
      sector_status_code: null,
      customer_since: moment().format(STANDARD_APP_DATE_FORMAT),
      website: "",
      facebook: "",
      linkedin: "",
    },
    loading: LoadState.NotLoaded,
  },

  customerRelatedAccount: {
    data: [],
    loading: LoadState.NotLoaded,
  },
  customerConsent: {
    data: {
      incremental_number: 0,
      customer_id: "",
      privacy_consent: "",
      privacy_act_consent: "",
      anti_spam_consent: "",
      telematics_consent_code: "",
      status: "ACTIVE",
      insert_ts: "",
    },
    loading: LoadState.NotLoaded,
  },
  opportunity: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
  },
  customerConsentList: {
    data: [],
    loading: LoadState.NotLoaded,
  },
  customerGroupsList: {
    data: [],
    loading: LoadState.NotLoaded,
  },

  customerContacts: {
    data: [],
    loading: LoadState.NotLoaded,
  },
  policies: {
    data: [],
    loading: LoadState.NotLoaded,
  },
  error: "",
};
